import { render, staticRenderFns } from "./DirectorsCloud.vue?vue&type=template&id=2c65fefe&scoped=true"
import script from "./DirectorsCloud.vue?vue&type=script&lang=js"
export * from "./DirectorsCloud.vue?vue&type=script&lang=js"
import style0 from "./DirectorsCloud.vue?vue&type=style&index=0&id=2c65fefe&prod&scoped=true&lang=css"
import style1 from "./DirectorsCloud.vue?vue&type=style&index=1&id=2c65fefe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65fefe",
  null
  
)

export default component.exports